/**
 * Hostname helpers — primary (denvoramobility.*) + legacy (goldportugal.*) during migration.
 * UI language: `.pt` → Portuguese · `.com` → English.
 */

import type { SiteLanguage } from "./platform";

export const PRIMARY_HOSTS = {
  pt: "denvoramobility.pt",
  en: "denvoramobility.com",
} as const;

const LEGACY_HOST_MARKERS = {
  pt: "goldportugal.pt",
  en: "goldportugal.com",
} as const;

export function isPtTldHostname(hostname: string): boolean {
  const h = hostname.toLowerCase();
  return h.includes(PRIMARY_HOSTS.pt) || h.includes(LEGACY_HOST_MARKERS.pt);
}

export function isComTldHostname(hostname: string): boolean {
  const h = hostname.toLowerCase();
  return h.includes(PRIMARY_HOSTS.en) || h.includes(LEGACY_HOST_MARKERS.en);
}

/** @deprecated Use isComTldHostname — kept for SEO canonical TLD checks */
export function isEnHostname(hostname: string): boolean {
  return isComTldHostname(hostname);
}

/** @deprecated Use isPtTldHostname — kept for SEO canonical TLD checks */
export function isPtHostname(hostname: string): boolean {
  return isPtTldHostname(hostname);
}

/** Default UI language from production hostname (`.pt` → PT, `.com` → EN). */
export function getLanguageFromHostname(hostname: string): SiteLanguage | null {
  if (!isProductionSiteHostname(hostname)) return null;
  if (isPtTldHostname(hostname)) return "pt";
  if (isComTldHostname(hostname)) return "en";
  return "en";
}

export function getPrimaryHost(lang: SiteLanguage): string {
  return PRIMARY_HOSTS[lang];
}

export function isProductionSiteHostname(hostname: string): boolean {
  return isPtTldHostname(hostname) || isComTldHostname(hostname);
}
